import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function VisitsPage() {
  return (
    <InteractionList
      type={InteractionTypes.VISIT}
      direction="received"
      title="Visites sur mon profil"
      emptyMessage="Aucune visite sur votre profil pour le moment."
    />
  );
}
